const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { decode } = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  
  const headers = {
    Accept: 'application/json',
  };
  
  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }


  return {
    
    getInvestmentFilterapi( base64Assets,base64Actions,metaData) {

      const arrayOfSelectedAssets = JSON.parse(decode(base64Assets));
      const arrayOfSelectedActions = JSON.parse(decode(base64Actions));

      const url = getUrl('investmentIdeas'); 
      const parsedMetaData = parseRequestMetaData(metaData);

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json:true
      };

      const body = {
        "assets": arrayOfSelectedAssets,
        "actions": arrayOfSelectedActions,
        "userId":parsedMetaData.qs.userId  
      }
     
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },


    getAssetNames(metaData) {

      const url = getUrl('investmentIdeasAssets');  
      const parsedMetaData = parseRequestMetaData(metaData);

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),  
        method: 'POST',
        timeout: 120000
      };

      const body = {
        "userId":parsedMetaData.qs.userId  
      };

      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));

    },

    getArticle(articleId,metaData) {
 
      articleId = articleId.replace(/i/gi,'');
  
      const url = getUrl('investmentIdeasDetails');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };
 
      /* Need to pass db entitlement actions*/
 
      const body = {
        "userId" : parsedMetaData.qs.userId, 
        "commId": articleId 
      };
 
      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));
 
    },

    searchInvestmentIdeas(text, metaData) {
      const url = getUrl('searchInvestmentIdeas')
      // const url = 'https://int3.mna.pwm.intranet.db.com/spotlight/api/search/communications';
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
 
      const body = {
        "searchText" : text.slice(7),
        "userId": parsedMetaData.qs.userId
      };
 
      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));
 
    },

  };
}

module.exports = apiFactory;
